module.exports = __webpack_public_path__ + "static/media/FIlter.23f867c6.svg";